import React from 'react';
import clsx from 'clsx';
import styles from './Form.module.scss';

type Props = {
  className?: string;
  children: React.ReactNode;
  onSubmit?: (e: React.FormEvent<HTMLFormElement>) => void;
};

const Form = React.forwardRef<HTMLFormElement, Props>((props, ref): JSX.Element => {
  const {
    className,
    children,
    onSubmit,
    ...other
  } = props;

  return (
    <form
      ref={ref}
      className={clsx(styles.root, className)}
      onSubmit={onSubmit}
      {...other}
    >
      {children}
    </form>
  );
});

export default React.memo(Form);
